import { faker } from "@faker-js/faker";

// ----------------------------------------------------------------------
const data = [
  { id: 1, name: "Prashant Trivedi", role: "UI UX, and Front-end Developer" },
  { id: 2, name: "DP Vishwakarma", role: "Digital Marketing Expert" },
  { id: 3, name: "Rahul Yadav", role: "SEO Expert" },
  { id: 4, name: "Sakshi Uniyal", role: "PR Expert" },
  { id: 5, name: "Aditi Guleria", role: "SEO Expert" },
  { id: 6, name: "Rashmi Kanti", role: "Content Writer" },
  { id: 7, name: "Ajit Samal", role: "SEO Expert" },
  { id: 8, name: "Jubin Sharma", role: "Social Media Expert" },
  { id: 9, name: "Ashwarya Ralhan", role: "Content Writer" },
  { id: 10, name: "Harsh Agarwal", role: "PR Expert" },
  { id: 11, name: "Saransh Sagar", role: "Digital Marketing Expert" },
  { id: 12, name: "Pranav Jha", role: "Google Ad Expert" },
  { id: 13, name: "Varun Tyagi", role: "UI UX, and Front-end Developer" },
  { id: 14, name: "Narveer Singh", role: "Digital Marketing Expert" },
  { id: 15, name: "Tushar Srivastava", role: "Content Writer" },
  { id: 16, name: "Sharath", role: "PR Expert" },
  { id: 17, name: "Shahnoor Mansoori", role: "HTML Developer" },
  { id: 18, name: "Shubham Kumar", role: "Content Writer" },
  { id: 19, name: "Ghanshyam Jograna", role: "SEO Expert" },
  { id: 20, name: "Shubham Gupta", role: "SEO Expert" }
];

const developers = data.map((e) => ({
  ...e,
  details: faker.lorem.paragraphs(8)
}));

export default developers;
